import { useState, useEffect } from "react";
import { SMLogo } from "@/app/components/sm-logo";
import { verifyEmail } from "@/app/api/auth-client";

const REDIRECT_SECONDS = 5;

function getTokenFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  return params.get("token")?.trim() || null;
}

export function VerifyEmailPage() {
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);
  const [token] = useState(() => getTokenFromUrl());
  const [verifyError, setVerifyError] = useState<string | null>(null);

  // Call BFF to verify the token (fire-and-forget; we still show progress and redirect)
  useEffect(() => {
    if (!token) {
      setVerifyError("Link inválido ou sem token.");
      return;
    }
    verifyEmail(token).catch((err) => {
      const message = (err as { message?: string }).message ?? "Não foi possível confirmar o e-mail.";
      setVerifyError(message);
    });
  }, [token]);

  // Countdown then open main app on login (see getInitialAppRouteState: after_email_verify=1)
  useEffect(() => {
    if (countdown <= 0) {
      window.location.href = "/?after_email_verify=1";
      return;
    }
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const progressPercent = ((REDIRECT_SECONDS - countdown) / REDIRECT_SECONDS) * 100;

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <SMLogo className="w-20 h-20 drop-shadow-lg" />
          </div>
          <h1 className="text-2xl font-semibold text-foreground">Confirmação de e-mail</h1>
        </div>

        <div className="bg-card rounded-2xl shadow-xl p-8 border border-border space-y-4">
          <p className="text-muted-foreground text-center">
            Estamos confirmando seu email e você será redirecionado em breve…
          </p>

          {verifyError && (
            <div className="rounded-lg bg-amber-500/10 text-amber-700 dark:text-amber-400 text-sm p-3">
              {verifyError}
            </div>
          )}

          <div className="space-y-2">
            <div className="h-2 w-full rounded-full bg-primary/20 overflow-hidden">
              <div
                className="h-full rounded-full bg-primary transition-all duration-1000 ease-linear"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
            <p className="text-center text-sm text-muted-foreground">
              Redirecionando para o login em {countdown} {countdown === 1 ? "segundo" : "segundos"}…
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
